import api from "./AxiosInterceptor";
import EndpointConfig from "./EndpointService";

export const timeShifterAPIService = async (payload) => {
  const url = EndpointConfig("timeShifterUrl").replace(
    "{userid}",
    payload?.userid
  );
  const response = await api.put(url, payload);
  return response;
};
